//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  DARK_MODE_AUTO,
  DARK_MODE_LIGHT,
  DARK_MODE_DARK
} from '@/lib/constants'
import { toggleDarkMode } from '@/lib/darkmode'
import { UserPrefs } from '@/lib/prefs'

export default {
  name: 'DarkModeToggle',
  data() {
    return {
      DARK_MODE_AUTO,
      DARK_MODE_LIGHT,
      DARK_MODE_DARK,
      prefs: new UserPrefs(this.$store),
      icons: {
        [[DARK_MODE_AUTO]]: 'circle-half-stroke',
        [[DARK_MODE_LIGHT]]: 'brightness',
        [[DARK_MODE_DARK]]: 'moon'
      }
    }
  },
  methods: {
    setDarkMode(mode) {
      this.prefs.darkMode = mode
      toggleDarkMode(mode)
    }
  },
  computed: {
    indicatorIcon() {
      return this.icons[this.prefs.darkMode || DARK_MODE_LIGHT]
    }
  }
}
